import { TFunction } from 'i18next';

import { type Project } from '@/api/typesense/projects';
import { StatusIndicatorVariant } from '@/components/ui/StatusIndicator/StatusIndicator';
import { legacyRoutes } from '@/constants/legacyRoutes';
import { routes } from '@/constants/routes';
interface Recommendation {
  condition: boolean | undefined;
  variant: StatusIndicatorVariant;
  title: string;
  description: string;
  actionLabel: string;
  actionLink: string;
}

export const getProjectRecommendations = (
  project: Project,
  translations: TFunction,
  hasNewProjectManagement?: boolean,
): Recommendation[] => {
  const recommendations: Recommendation[] = [
    {
      condition: project.HasOverdueTasks,
      variant: 'atRisk',
      title: translations('projectRecommendation.hasOverdueTasks.Title'),
      description: translations(
        'projectRecommendation.hasOverdueTasks.Description',
      ),
      actionLabel: translations(
        'projectRecommendation.hasOverdueTasks.ButtonText',
      ),
      actionLink: hasNewProjectManagement
        ? routes.projects.planning(project.SourceId)
        : legacyRoutes.projectManagement.index(project.SourceId),
    },
    {
      condition: project.IsRegisteredTimeExceedingTaskBudget,
      variant: 'atRisk',
      title: translations(
        'projectRecommendation.isRegisteredTimeExceedingTaskBudget.Title',
      ),
      description: translations(
        'projectRecommendation.isRegisteredTimeExceedingTaskBudget.Description',
      ),
      actionLabel: translations(
        'projectRecommendation.isRegisteredTimeExceedingTaskBudget.ButtonText',
      ),
      actionLink: hasNewProjectManagement
        ? routes.projects.planning(project.SourceId)
        : legacyRoutes.projectManagement.index(project.SourceId),
    },
    // Saved for future usage
    // {
    //   condition: project.IsAllocationExceedingTaskBudget,
    //   variant: 'atRisk',
    //   title: translations('projectRecommendation.hasBudgetOverrun.Title'),
    //   description: translations(
    //     'projectRecommendation.hasBudgetOverrun.Description',
    //   ),
    //   actionLabel: translations(
    //     'projectRecommendation.hasBudgetOverrun.ButtonText',
    //   ),
    //   actionLink: hasNewProjectManagement
    //     ? routes.projects.planning(project.SourceId)
    //     : legacyRoutes.projectManagement.index(project.SourceId),
    // },
    // {
    //   condition: project.IsRegisteredTimeExceedingAllocation,
    //   variant: 'atRisk',
    //   title: 'Registered time exceeding allocation',
    //   description:
    //     'Time tracked on tasks exceeds the allocated hours. Consider updating allocations or reviewing time entries.',
    //   actionLabel: 'View time entries',
    //   actionLink: hasNewProjectManagement
    //     ? routes.projects.planning(project.SourceId)
    //     : legacyRoutes.projectManagement.index(project.SourceId),
    // },
    // {
    //   condition: project.IsTaskBudgetExceedingContractBudget,
    //   variant: 'atRisk',
    //   title: 'Task budget exceeding contract budget',
    //   description:
    //     'Planned task budget exceeds the agreed contract budget. Review and adjust task estimates or renegotiate contract.',
    //   actionLabel: 'View budget',
    //   actionLink: hasNewProjectManagement
    //     ? routes.projects.planning(project.SourceId)
    //     : legacyRoutes.projectManagement.index(project.SourceId),
    // },
    // {
    //   condition: project.IsTaskBudgetExceedingProjectBudget,
    //   variant: 'atRisk',
    //   title: 'Task budget exceeding project budget',
    //   description:
    //     'Task budget exceeds overall project budget. Adjust task estimates or increase project budget allocation.',
    //   actionLabel: 'View budget',
    //   actionLink: hasNewProjectManagement
    //     ? routes.projects.planning(project.SourceId)
    //     : legacyRoutes.projectManagement.index(project.SourceId),
    // },
  ];

  const activeRecommendations = recommendations.filter((rec) => rec.condition);

  return activeRecommendations;
};
